import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GoogleCircleFilledSvg from "@ant-design/icons-svg/es/asn/GoogleCircleFilled";
import AntdIcon from '../components/AntdIcon';
var GoogleCircleFilled = function GoogleCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: GoogleCircleFilledSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(GoogleCircleFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'GoogleCircleFilled';
}
export default RefIcon;